// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:29
import { RTMSEngagementType_abstract } from './../abstract/SagaSchema/RTMSEngagementType_abstract';
export class RTMSEngagementType extends RTMSEngagementType_abstract {}
